export default "__VITE_ASSET__DcH9FtoX__"